var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"main",attrs:{"role":"main"}},[_c('div',{staticClass:"main_con"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card_date"},[_vm._v(" "+_vm._s(_vm.article?.createdAt)+" ")]),_c('div',{staticClass:"editor"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.article?.content)}})])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }